import { ReactElement } from 'react';

import { commonTranslationKeys, FormContextValues } from '@dreryk/react-common';
import {
   appendTestableComponentAttributes,
   Heading,
   Notification,
   NotificationSize,
   NotificationType,
   PostcodeInput,
   StyledFlex,
} from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../../../../translations';

import { StyledAddressSection } from './AddressSection.styled';
import { AddressFormBeanPart, WithAddressFormBeanPart } from './AddressSection.types';
import { BuildingField } from './fields/BuildingField';
import { FlatField } from './fields/FlatField';
import { IncludeAddressField } from './fields/IncludeAddressField';
import { StreetField } from './fields/StreetField';
import { TownField } from './fields/TownField';

const isSectionWithIncludedAddress = (
   register: FormContextValues<AddressFormBeanPart>['register'],
   includeAddress: boolean
): register is FormContextValues<WithAddressFormBeanPart>['register'] => {
   return includeAddress;
};

type AddressSectionProps = Pick<FormContextValues<AddressFormBeanPart>, 'register' | 'watch'>;

export const AddressSection = (props: AddressSectionProps): ReactElement => {
   const includeAddress = props.watch('includeAddress');

   return (
      <div>
         <Heading content={personnelTranslationKeys.address.address} testId={'address'} type={'h2'} />
         <StyledFlex direction={'column'} gap={'12px'}>
            <Notification
               testId={'addressIsOptional'}
               type={NotificationType.INFO}
               size={NotificationSize.SMALLER}
               label={personnelTranslationKeys.address.optionalAddressForPrescriptionsProAuctore}
            />
            <IncludeAddressField register={props.register} />
            {isSectionWithIncludedAddress(props.register, includeAddress) ? (
               <StyledAddressSection {...appendTestableComponentAttributes('AddressSection', 'addressSection')}>
                  <StreetField register={props.register} />
                  <BuildingField register={props.register} />
                  <FlatField register={props.register} />
                  <TownField register={props.register} />
                  <PostcodeInput
                     testId={'postcode'}
                     label={commonTranslationKeys.addressData.zipCode}
                     controller={props.register('postcode', { required: true })}
                  />
               </StyledAddressSection>
            ) : null}
         </StyledFlex>
      </div>
   );
};
